import { render } from "./NotFound.vue?vue&type=template&id=7c217df4&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=7c217df4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c217df4"

export default script